import api from './axiosInstance';

export const measurementApi = {
  // Catalog items
  listCatalogItems: (includeDisabled, itemType) =>
    api.get('/catalog-items', {
      params: {
        ...(includeDisabled ? {includeDisabled: true} : {}),
        ...(itemType ? {itemType} : {}),
      },
    }),
  getCatalogItem: id => api.get(`/catalog-items/${id}`),
  createCatalogItem: data => api.post('/catalog-items', data),
  updateCatalogItem: (id, data) => api.put(`/catalog-items/${id}`, data),
  toggleCatalogItem: (id, data) => api.put(`/catalog-items/${id}/toggle`, data),
  deleteCatalogItem: id => api.delete(`/catalog-items/${id}`),
  syncSeedData: () => api.post('/catalog-items/sync-seed'),

  // Measurement fields
  listFields: catalogItemId => api.get(`/catalog-items/${catalogItemId}`),
  addField: (catalogItemId, data) =>
    api.post(`/catalog-items/${catalogItemId}/fields`, data),
  updateField: (catalogItemId, fieldId, data) =>
    api.put(`/catalog-items/${catalogItemId}/fields/${fieldId}`, data),
  removeField: (catalogItemId, fieldId) =>
    api.delete(`/catalog-items/${catalogItemId}/fields/${fieldId}`),
  reorderFields: (catalogItemId, orderedIds) =>
    api.put(`/catalog-items/${catalogItemId}/fields/reorder`, {orderedIds}),

  // Option type mappings for catalog items
  getOptionTypes: catalogItemId =>
    api.get(`/catalog-items/${catalogItemId}/option-types`),
  toggleOptionType: (catalogItemId, data) =>
    api.put(`/catalog-items/${catalogItemId}/option-types`, data),
  reorderOptionTypes: (catalogItemId, orderedIds) =>
    api.put(`/catalog-items/${catalogItemId}/option-types/reorder`, {orderedIds}),

  // Measurement values (catalog item option values for MEASUREMENT_TYPE)
  getMeasurementValues: (catalogItemId) =>
    api.get(`/catalog-items/${catalogItemId}/measurement-values`),
  toggleMeasurementValue: (catalogItemId, valueId, data) =>
    api.put(`/catalog-items/${catalogItemId}/measurement-values/${valueId}`, data),
  toggleMeasurementByGlobalOption: (catalogItemId, data) =>
    api.put(`/catalog-items/${catalogItemId}/measurement-values`, data),
  reorderMeasurementValues: (catalogItemId, orderedIds) =>
    api.put(`/catalog-items/${catalogItemId}/measurement-values/reorder`, {orderedIds}),

  // Body measurement profiles
  getBodyProfile: (customerId) =>
    api.get(`/customers/${customerId}/measurements/body`),
  saveBodyProfile: (customerId, data) =>
    api.post(`/customers/${customerId}/measurements/body`, data),

  // Customer measurement profiles
  listProfiles: (customerId, catalogItemId) =>
    api.get(`/customers/${customerId}/measurements`, {
      params: catalogItemId ? {catalogItemId} : {},
    }),
  getProfile: (customerId, profileId) =>
    api.get(`/customers/${customerId}/measurements/${profileId}`),
  createProfile: (customerId, data) =>
    api.post(`/customers/${customerId}/measurements`, data),
  updateProfile: (customerId, profileId, data) =>
    api.put(`/customers/${customerId}/measurements/${profileId}`, data),
  deleteProfile: (customerId, profileId) =>
    api.delete(`/customers/${customerId}/measurements/${profileId}`),
};
